<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width:20px" /> Ingrediant
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="speciesItem"
            :fields="fields"
            pagination
            clickable-rows
              table-filter
          items-per-page-select
          :items-per-page="10"
            hover
            @row-clicked="rowClicked"
            caption="Species"
          />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width:20px" /> Ingrediant Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput label="Code" horizontal autocomplete="name" v-model="code" />
            <CInput label="Name" horizontal autocomplete="name" v-model="name" />
            <CInput label="Group" horizontal autocomplete="name" v-model="group" />
            <CRow>
              <CCol sm="3">
                <h5 style="font-size:15px">Active</h5>
              </CCol>
              <CCol sm="3">
                <input type="checkbox" id="active" v-model="active" value="on" />
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addSpecies">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteSpecies">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
          <CButton color="secondary" style="width:100px" v-if="cancelButton" @click="Cancelspecies">
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>

          <CButton color="info" v-if="addnewButton" @click="addnewspecies">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../../tables/Table";
import { APIService } from "../../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper },
  data() {
    return {
      fields: [
        {
          key: "code",
          sortable: true
        },
        {
          key: "name",
          sortable: true
        },
        {
          key: "group",
          sortable: true
        },
        {
          key: "active",
          sortable: true
        }
      ],

      code: null,
      name: "",
      group: "",
      active: false,
      speciesItem: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false
    };
  },
  methods: {
    getingradiantList() {
      APIService.ingradiantList().then(res => {
        if (res.status == 200) {
          this.speciesItem = res.data;

           this.code =  this.speciesItem[0].code;
      this.name = this.speciesItem[0].name;
      this.group = this.speciesItem[0].group;
        }
      });
    },
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editSpecies = item;
      this.code = item.code;
      this.name = item.name;
      this.group = item.group;
      this.active = item.active;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addnewspecies() {
      this.code = null;
      this.name = "";
      this.group = "";
      this.active = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      this.EditsaveButton = true
      return getingradiantList();
    },
    Cancelspecies() {
      this.code = null;
      this.name = "";
      this.group = "";
      this.active = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false,
       this.getingradiantList();
    },

    addSpecies() {
      let code = this.code;
      let name = this.name;
      let group = this.group;
      let active = this.active;
      let data = {
        code,
        name,
        group,
        active
      };
      APIService.saveIngradiant(data).then(res => {
        if (res.status == 200) {
          this.code = null;
          this.name = "";
          this.group = "";
          this.active = "";
          this.getingradiantList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    updateSpecies() {
      let id = this.editSpecies._id;
      let code = this.code;
      let name = this.name;
      let group = this.group;
      let active = this.active;
      let value = {
      code,
        name,
        group,
        active
      };
      let data = { id, value };
      APIService.ingradiantUpdate(data).then(res => {
        if (res.status == 200) {
            this.code = null;
          this.name = "";
          this.group = "";
          this.active = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
         this.getingradiantList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    deleteSpecies() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    delete() {
      let id = this.editSpecies._id;
      let data = { id };
      APIService.ingradiantDelete(data).then(res => {
        if (res.status == 200) {
           this.code = null;
          this.name = "";
          this.group = "";
          this.active = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.EditsaveButton = false,
             this.getingradiantList();
        }
      });
    }
  },
  created() {
    this.getingradiantList();
  }
};
</script>
<style scoped>
tbody > tr > :nth-child(1) {
  color: red;
  width: 200px;
  text-align: center;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: inset;
}
</style>